var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.5C2 4.11929 3.11929 3 4.5 3H19.5C20.8807 3 22 4.11929 22 5.5C22 6.88071 20.8807 8 19.5 8H13.25V6.75C13.25 6.05964 12.6904 5.5 12 5.5C11.3096 5.5 10.75 6.05964 10.75 6.75V8H4.5C3.11929 8 2 6.88071 2 5.5ZM3.25006 10.25H10.7501V20H5.75006C4.36935 20 3.25006 18.8807 3.25006 17.5V10.25ZM18.2501 20H13.2501V10.25H20.7501V17.5C20.7501 18.8807 19.6308 20 18.2501 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackaging);
export default __webpack_public_path__ + "static/media/packaging.6bdc03e14dcc5e082d1c426feb22fac4.svg";
export { ForwardRef as ReactComponent };